var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "admin-main" }, [
    _c("div", { staticClass: "page-content" }, [
      _c("div", { staticClass: "left-menu" }, [_c("left-menu-list")], 1),
      _vm._v(" "),
      _c("div", { staticClass: "page-main" }, [
        _c("div", { staticClass: "clearfix logo-and-personal" }, [
          _c(
            "div",
            { staticClass: "page-breadcrumb" },
            [
              _c(
                "el-breadcrumb",
                { attrs: { separator: "/" } },
                [
                  _vm.currentPath.meta
                    ? _c(
                        "el-breadcrumb-item",
                        { attrs: { to: { path: "/home" } } },
                        [_vm._v("首页")]
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  !_vm.currentPath.meta
                    ? _c("el-breadcrumb-item", [_vm._v("首页")])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.currentPath.meta
                    ? _c("el-breadcrumb-item", [
                        _vm._v(_vm._s(_vm.currentPath.meta.title))
                      ])
                    : _vm._e()
                ],
                1
              )
            ],
            1
          ),
          _vm._v(" "),
          _c(
            "div",
            { staticClass: "personal-details" },
            [
              _c(
                "el-dropdown",
                [
                  _c("span", { staticClass: "el-dropdown-link" }, [
                    _c(
                      "span",
                      {
                        staticClass: "ellipsis",
                        staticStyle: {
                          display: "inline-block",
                          height: "16px",
                          width: "100px",
                          cursor: "pointer"
                        },
                        attrs: { title: "这是一个账号这是一个账号" }
                      },
                      [
                        _vm._v(
                          "用户名：" +
                            _vm._s(this.$store.getters.userInfo.userName)
                        )
                      ]
                    ),
                    _c("i", {
                      staticClass: "el-icon-arrow-down el-icon--right",
                      staticStyle: { "vertical-align": "middle" }
                    })
                  ]),
                  _vm._v(" "),
                  _c(
                    "el-dropdown-menu",
                    { attrs: { slot: "dropdown" }, slot: "dropdown" },
                    [
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.info()
                            }
                          }
                        },
                        [_vm._v("个人资料")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          nativeOn: {
                            click: function($event) {
                              return _vm.updatePwd()
                            }
                          }
                        },
                        [_vm._v("修改密码")]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-dropdown-item",
                        {
                          attrs: { divided: "" },
                          nativeOn: {
                            click: function($event) {
                              return _vm.loginOut()
                            }
                          }
                        },
                        [_vm._v("退出登录")]
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "page-wrapper" }, [_c("router-view")], 1)
      ])
    ]),
    _vm._v(" "),
    _vm._m(0)
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "logo-div" }, [
      _c("img", { attrs: { src: require("../assets/img/logo.png") } })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-c9a65f5a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-c9a65f5a","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/main.vue
// module id = null
// module chunks = 